import React, { useState, useEffect } from 'react'
import AvailabilityDataTable from 'components/AvailabilityDataTable'

const AgencyAvailability = ({ agency }) => {
  const [availabilities, setAvailabilities] = useState([])
  if (!agency) {
    return null
  }

  useEffect(() => {
      fetch(`/rest/v2/agency/${agency.uid}/availability`, { credentials: 'same-origin' }) 
        .then((response) => response.json())
        .then(({data}) => setAvailabilities(data.sort((a, b) => (
          a.dateStart > b.dateStart ? 1 : -1
        )))) 
        .catch((error) => toastr.error(error))
  }, [agency])

  const onSave = (prevEvent, nextEvent) => {
    let promise
    const body = JSON.stringify(nextEvent)

    if (prevEvent && 'uid' in prevEvent) {
      promise = fetch(`/rest/v2/agency/${agency.uid}/availability/${prevEvent.uid}`, { method: 'PUT', body, credentials: 'same-origin' }) 
    } else {
      promise = fetch(`/rest/v2/agency/${agency.uid}/availability`, { method: 'POST', body, credentials: 'same-origin' }) 
    }

    promise
      .then((response) => {
        if (response.status === 406) {
          const start = new Date();
          start.setUTCSeconds(nextEvent.dateStart);

          const end = new Date();
          end.setUTCSeconds(nextEvent.dateEnd);

          throw new Error(`Unavailability already requested from ${start.toLocaleDateString("en-GB")} to ${end.toLocaleDateString("en-GB")  } with message \"${nextEvent.message}\"`);
        }

        return response.json()
      })
      .then(({data}) => {
        if (data.errors) {
          return toastr.error(`${data.message}. ${data.errors.join('. ')}`)
        }

        if (availabilities.find((availability) => availability.uid == data.uid)) { //Edit availability
          setAvailabilities(availabilities.map((availability) => {
            if (availability.uid == data.uid) {
              return data
            } else {
              return availability
            }
          }))
        } else { // New availability
          setAvailabilities([...availabilities, data])
        }
      })
      .catch((error) => toastr.error(error))
  }

  const onDelete = (availabilityId) => {
    fetch(`/rest/v2/agency/${agency.uid}/availability/${availabilityId}`, { method: 'DELETE', credentials: 'same-origin' }) 
      .then(() => setAvailabilities((availability) => availability.filter(({ uid }) => uid !== availabilityId)))
      .catch((error) => toastr.error(error))
  }

  return (
    <div className='mt-2'>
      <AvailabilityDataTable
        availabilities={availabilities}
        onSave={(prevEvent, nextEvent) => onSave(prevEvent, nextEvent)}
        onDelete={(availabilityId) => onDelete(availabilityId)}
        includeAvailabilityRequest
      />
    </div>
  )
}

export default AgencyAvailability
